import { useTranslation } from 'next-i18next';
import { type QuizBankFilterOption } from '../types';
import { QuizBankFilterOptionRow } from './QuizBankFilterOptionRow';
interface QuizBankUnitFilterProps {
  options: QuizBankFilterOption[];
  onToggleUnit: (unitId: string) => void;
}

/** 단원 필터 — 평탄한 복수 선택. 학년 radio 가 범위를 좁혀 주므로 트리가 없다. */
export const QuizBankUnitFilter = ({
  options,
  onToggleUnit
}: QuizBankUnitFilterProps) => {
  const {
    t
  } = useTranslation(['build']);
  return <section className="flex flex-col gap-3xs" data-sentry-component="QuizBankUnitFilter" data-sentry-source-file="QuizBankUnitFilter.tsx">
      <h3 className="px-2xs text-body-sm-bold text-alternative">
        {t('build:quizBank.filter.unit')}
      </h3>
      <div className="flex flex-col">
        {options.map(option => <QuizBankFilterOptionRow key={option.id} option={option} showCount onToggle={onToggleUnit} />)}
      </div>
    </section>;
};